import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader, ComponentFooter } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/type/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
        # Get package information by NPM package name.
        packageTable: thumbprintComponent(name: { eq: "@thumbtack/thumbprint-scss" }) {
            ...PackageTableFragment
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Title`}</h2>
    <p>{`These type styles uses `}<a parentName="p" {...{
        "href": "/tokens/#section-type"
      }}>{`variables from Thumbprint Tokens`}</a>{`. You can refer to that documentation for font-size, line-height, and font-weight values.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-1">
    28px (mobile) / 40px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-2">
    24px (mobile) / 32px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-3">
    22px (mobile) / 24px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-4">
    20px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-5">
    18px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-6">
    16px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-7">
    14px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-title-8">
    12px is the title size and can run as long as it needs to to fill up the space.
</div>
`}</code></pre>
    <h2>{`Body`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-body-1">
    16px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-body-2">
    14px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-body-3">
    12px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <h2>{`Deprecated body text`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-text-1">
    20px (mobile) / 24px is the text size that forms sentences and can run as long as it needs to to
    fill up the space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-text-1--static">
    20px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-text-2--static">
    16px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-text-3--static">
    14px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-text-4--static">
    12px is the text size that forms sentences and can run as long as it needs to to fill up the
    space. It should still look good.
</div>
`}</code></pre>
    <h2>{`Deprecated Headings`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-1">
    32px (mobile) / 48px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-2">
    30px (mobile) / 40px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-3">
    24px (mobile) / 32px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-4">
    20px (mobile) / 24px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-5">
    16px (mobile) / 20px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div class="tp-heading-6">
    14px (mobile) / 16px is our heading size and it too may run long and wrap to a second line but
    we should be ready for that.
</div>
`}</code></pre>
    <ComponentFooter data={props.data} mdxType="ComponentFooter" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      